// MapComponent.jsx
import React from 'react';
import { MapContainer, TileLayer, Marker, Tooltip } from 'react-leaflet';
import L from 'leaflet';

// Fix default icon issue
import 'leaflet/dist/leaflet.css';
import { useSelector } from 'react-redux';
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const MapComponent = ({ locations }) => {
    const language = useSelector((state) => state.language.language)
  const center = locations.length > 0
    ? [locations[0]?.Location?.latitude, locations[0]?.Location?.longitude]
    : [0, 0];

  return (
    <MapContainer center={center} zoom={5} style={{ height: '400px', width: '100%' }}>
      <TileLayer
        attribution='&copy; OpenStreetMap contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {locations.map((loc, index) => (
        <Marker
          key={index}
          position={[loc?.Location?.latitude, loc?.Location?.longitude]}
        >
          <Tooltip direction="top" offset={[0, -10]} opacity={1} permanent={false}>
      {loc?.title?.[language] || `Lat: ${loc?.Location?.latitude}, Lng: ${loc?.Location?.longitude}`}
    </Tooltip>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default MapComponent;
